export const mockProjects = [
  {
    id: "1",
    title: "ابتکار آموزش دختران",
    category: "Education",
    description: "ارائه بورسیه‌ها، لوازم مکتب و محیط‌های آموزشی امن برای دختران در ولایات کابل و قندهار.",
    image: "https://readdy.ai/api/search-image?query=Afghan%20girls%20studying%20in%20a%20bright%20classroom%20with%20books%20and%20colorful%20supplies%2C%20warm%20natural%20lighting%2C%20hopeful%20atmosphere%2C%20clean%20simple%20background&width=800&height=500&seq=proj1&orientation=landscape",
    raised: 48200,
    goal: 60000,
    status: "active",
    location: "کابل و قندهار",
    beneficiaries: 320,
  },
  {
    id: "2",
    title: "برنامه دسترسی به آب پاک",
    category: "Infrastructure",
    description: "نصب سیستم‌های تصفیه آب و چاه‌ها در روستاهای افغانستان برای تأمین آب آشامیدنی پاک برای هزاران خانواده.",
    image: "https://readdy.ai/api/search-image?query=Clean%20water%20well%20installation%20in%20a%20rural%20Afghan%20village%2C%20community%20members%20gathering%2C%20bright%20sunny%20day%2C%20simple%20background&width=800&height=500&seq=proj2&orientation=landscape",
    raised: 31500,
    goal: 45000,
    status: "active",
    location: "ولایت هلمند",
    beneficiaries: 1200,
  },
  {
    id: "3",
    title: "کلینیک‌های سیار صحی",
    category: "Healthcare",
    description: "استقرار واحدهای سیار طبی با کادر داوطلب پزشکان برای ارائه مراقبت‌های اولیه صحی در جوامع محروم.",
    image: "https://readdy.ai/api/search-image?query=Mobile%20medical%20clinic%20in%20Afghanistan%2C%20doctor%20treating%20patients%20outdoors%2C%20clean%20white%20medical%20tent%2C%20warm%20compassionate%20atmosphere&width=800&height=500&seq=proj3&orientation=landscape",
    raised: 22800,
    goal: 35000,
    status: "active",
    location: "ولایت ننگرهار",
    beneficiaries: 850,
  },
  {
    id: "4",
    title: "مراکز آموزش حرفه‌ای",
    category: "Education",
    description: "آموزش مهارت‌های قابل فروش — خیاطی، نجاری، تکنالوژی معلوماتی و زراعت — به جوانان و زنان بیکار.",
    image: "https://readdy.ai/api/search-image?query=Afghan%20youth%20learning%20vocational%20skills%20in%20a%20training%20workshop%2C%20sewing%20machines%20and%20tools%2C%20focused%20students%2C%20bright%20indoor%20setting&width=800&height=500&seq=proj4&orientation=landscape",
    raised: 18900,
    goal: 28000,
    status: "active",
    location: "هرات",
    beneficiaries: 210,
  },
  {
    id: "5",
    title: "حمایت از اسکان مجدد پناهندگان",
    category: "Community",
    description: "کمک به خانواده‌های پناهنده افغان در کانادا برای ادغام از طریق کلاس‌های زبان، کمک مسکن و راهنمایی اشتغال.",
    image: "https://readdy.ai/api/search-image?query=Afghan%20refugee%20family%20in%20Canada%20receiving%20community%20support%2C%20warm%20welcoming%20environment%2C%20multicultural%20setting%2C%20hopeful%20expressions&width=800&height=500&seq=proj5&orientation=landscape",
    raised: 55000,
    goal: 55000,
    status: "completed",
    location: "تورنتو و اوتاوا",
    beneficiaries: 480,
  },
  {
    id: "6",
    title: "کمپین کمک‌های زمستانی",
    category: "Humanitarian",
    description: "توزیع لباس گرم، کمپل و بسته‌های غذایی به خانواده‌های آسیب‌پذیر در زمستان‌های سخت افغانستان.",
    image: "https://readdy.ai/api/search-image?query=Humanitarian%20aid%20distribution%20in%20Afghanistan%2C%20volunteers%20handing%20out%20warm%20blankets%20and%20food%20packages%20to%20families%20in%20winter%2C%20compassionate%20scene&width=800&height=500&seq=proj6&orientation=landscape",
    raised: 12400,
    goal: 20000,
    status: "active",
    location: "چندین ولایت",
    beneficiaries: 600,
  },
];

export const mockStats = [
  { label: "دانش‌آموزان حمایت شده", value: "۲,۵۰۰+" },
  { label: "پروژه‌های فعال", value: "۱۵" },
  { label: "سال‌های تأثیر", value: "۸" },
  { label: "داوطلبان", value: "۳۴۰+" },
];